import {Analytics, type IAnalytics} from '@sail/observability';
import {isAnalyticsDisabled} from './isAnalyticsDisabled';
import type {AnalyticsRecord} from './AnalyticsTypes';
import {getPageViewId} from './getPageViewId';
import {submerchantAnalyticsParams} from '../data-layer-client/submerchantAnalyticsParams';
import {AnalyticsWrapper} from './AnalyticsWrapper';

const analyticsInstance = new Analytics({
  project: 'accounts_ui',
  service: 'connect-js',
  pageViewToken: getPageViewId(),
  analytics: {
    disabled: isAnalyticsDisabled(),
    disableCookies: true,
    parametersAllowList: Object.keys(submerchantAnalyticsParams),
  },
  // This will be removed once we verify that there's no data loss
  // between the two reporting systems (sdk/obs and SUS methods).
  _internal_observability: {
    analytics: {
      action(_, eventName, parameters) {
        AnalyticsWrapper.instance.action(eventName, parameters);
      },
      link(_, eventName, parameters) {
        AnalyticsWrapper.instance.link(eventName, parameters);
      },
      modal(_, eventName, parameters) {
        AnalyticsWrapper.instance.modal(eventName, parameters);
      },
      track(_, eventName, parameters) {
        AnalyticsWrapper.instance.track(eventName, parameters);
      },
      viewed(_, eventName, parameters) {
        AnalyticsWrapper.instance.viewed(eventName, parameters);
      },
    },
  },
});
let authMetadata: AnalyticsRecord | undefined;

export const setAuthMetadata = (metadata: AnalyticsRecord | undefined) => {
  authMetadata = metadata;
};

export const analytics: IAnalytics = {
  action(eventName, params) {
    analyticsInstance.action(
      eventName,
      Object.assign({}, authMetadata, params),
    );
  },
  link(eventName, params) {
    analyticsInstance.link(eventName, Object.assign({}, authMetadata, params));
  },
  track(eventName, params) {
    analyticsInstance.track(eventName, Object.assign({}, authMetadata, params));
  },
  viewed(eventName, params) {
    analyticsInstance.viewed(
      eventName,
      Object.assign({}, authMetadata, params),
    );
  },
  modal(eventName, params) {
    analyticsInstance.modal(eventName, Object.assign({}, authMetadata, params));
  },
};
